<template>
    <div class="d-flex gap20">

      <div style="flex: 1;">
        <div class="step-title-label">Control your optimization level</div>
        <div class="mt-2">Adjust how much optimization you want in your article.</div>
      </div>

      <div style="flex: 2;">
        <div class="d-flex gap10 align-center">
          <v-tooltip
            v-for="option in optimizationLevelOptions" :key="option.value"
            top color="black"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" v-on="on"
                outlined
                :class="{
                  'optimization-level-option text-none': true,
                  'active': optimizationLevel === option.value,
                }"
                :disabled="isDemo"
                @click="$emit('update:optimizationLevel', option.value);"
              >
                {{ option.text }}
              </v-btn>
            </template>
            <div class="p-2" style="max-width: 350px;">
              <div v-html="option.tooltip_html" />
            </div>
          </v-tooltip>
        </div>
      </div>

    </div>
</template>

<script>

export default {
    name: 'ConfigOptimizationLevel',
    props: [
        'isDemo',

        'optimizationLevelOptions',
        'optimizationLevel',
    ],
}
</script>

<style lang="scss" scoped>
.optimization-level-option {
  letter-spacing: initial;
  border-color: var(--v-gray12Color-base);
  &.active {
    border-color: #FF5C00;
    background-color: #FFF6F1;
  }
}

.theme--dark {
  .optimization-level-option {
    &.active {
      background-color: #383534;
    }
  }
}
</style>